// Imports (Generic)
import {
  init as windowResizeInit,
} from '../../tools/WindowResizeHandler';
import {
  init as dataLayerInit,
} from '../../DataLayer';

// Imports (Events)
import {
  headerReadyEventName,
} from '../../Events';

// Imports (Widgets)
import { init as imageManagerInit } from '../../widgets/ImageManager';

// Imports (Molecules)
import adaBannerInit from '../../molecule/ada-banner';
import cookiesLawInit from '../../molecule/cookies-law';

// Imports (Organisms)
import { init as popinInit } from '../../organism/popin';
import footerNewsletterInit from '../../organism/footer-newsletter';
import { init as footerInit } from '../../organism/footer';

import { init as qrTravelRetailInit } from '../../../generic/qr_travel_retail/qr_travel_retail';

/**
 * Initialization of the header part of the website.
 */
function init() {
  // Handle footer
  footerInit();

  // Widget
  imageManagerInit();

  // Handle window resize
  windowResizeInit();

  // Handle data layer
  dataLayerInit();

  // Handle popin init
  popinInit();

  qrTravelRetailInit();

  $(document).on(headerReadyEventName, () => {
    adaBannerInit();

    cookiesLawInit();

    footerNewsletterInit();
  });
}

// Named exports - Functions
export {
  init,
};

export default init;



// WEBPACK FOOTER //
// ./js/common/entries/header/init.js